module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAIFJREFUGBljZACCS3fuBzAw/M//z8BgwMjAIAAUOsD4n7FRV1XxACNUcj1IIToAKnJkYvj/vwBdAsb/z/C/gYmBkcEeJoBO/2dk0GdCF0Tl/2cEWsFwEFUQwQO64QLQCsYJCCFUFiMDYwOTnoriBgYGxkCQSUBHfQQrAbJBPgB5EwBmiSU1PvQIigAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/step-pending.png
// module id = 811
// module chunks = 14